import styled from 'styled-components'
import { font, bp } from 'lib/core/resources/helpers/styled'
import arrowDown from 'resources/svg/icons/qty-caret-down.svg'

export const Wrapper = styled.div<{ isSofiaAndGrace: boolean }>`
  .warning {
    color: ${props => props.theme.palette.state.danger};
    font: ${font('default', 'medium', '14px/1')};
  }

  .product {
    &__steps {
      font: ${font('alt', 'normal', '20px/1.2')};
      color: ${props => props.theme.palette.general.strong};
      margin: 0 0 1rem;
    }

    &__actions {
      border: 1px solid ${props => props.theme.palette.general.greyLight};
      border-width: 1px 0;
      margin: 0 -24px;
      padding: 18px 24px;
    }

    &__frequency-container {
      border: 1px solid ${props => props.theme.palette.general.greyLight};
      border-radius: 4px;
      background: ${props => props.theme.palette.general.greyExtraLight};
      overflow: hidden;

      > div {
        padding: 0 32px 35px;
      }
    }

    &__frequency-option {
      display: block;
      cursor: pointer;
      user-select: none;
      text-align: left;
      padding: 24px;

      &:not(.active) {
        background: ${props => props.theme.palette.general.light};
      }

      &:first-of-type {
        &:not(.active) {
          border-bottom: 1px solid ${props => props.theme.palette.general.greyLight};

          + label:not(.active) {
            border-top: none;
          }
        }
      }

      &:last-of-type {
        &:not(.active) {
          border-top: 1px solid ${props => props.theme.palette.general.greyLight};
        }
      }

      input {
        display: none;

        &:checked + strong::after {
          opacity: 1;
          transform: scale(1, 1);
        }
      }

      strong {
        padding-left: 24px;
        font: ${font('default', 'bold', '18px/1')};
        color: ${props => props.theme.palette.general.strong};
        display: inline-block;
        position: relative;

        &::before {
          content: '';
          display: block;
          position: absolute;
          top: 0;
          left: 0;
          border-radius: 50%;
          margin-right: 5px;
          width: 16px;
          height: 16px;
          border: 1px solid ${props => props.theme.palette.general.strong};
          background: ${props => props.theme.palette.general.light};
        }

        &::after {
          content: '';
          display: block;
          width: 10px;
          height: 10px;
          background: ${props => props.theme.palette.general.strong};
          position: absolute;
          border-radius: 50%;
          top: 4px;
          left: 4px;
          opacity: 0;
          transform: scale(0, 0);
          transition: all 0.2s cubic-bezier(0.64, 0.57, 0.67, 1.53);
        }
      }
    }
  }

  .return-subscriptions {
    width: 100%;
    background: ${props => props.theme.palette.general.light};
    border: none;
    padding: 10px;
    color: ${props => props.isSofiaAndGrace ? props.theme.palette.primary.gamma : props.theme.palette.primary.alphaDark};
    font-size: 14px;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }
  }
`
export const PriceWrapper = styled.div`
  margin-bottom: 20px;

  > span {
    color: ${props => props.theme.palette.general.strong};
    font: ${font('default', 'bold', '30px/1.5')};
  }

  p {
    font: ${font('default', 'normal', '14px/1')};
    margin: 0;
  }
`

export const ButtonWrapper = styled.div<any>`
  margin-top: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    background: ${props => props.theme.palette.primary.betaLight};
    border-color: ${props => props.theme.palette.primary.betaLight};
    text-transform: uppercase;
    font: ${font('default', 'bold', '14px/1')};
    width: 100%;
    max-width: 270px;
  }

  .product {
    &__subtotal {
      margin-right: 10px;

      label {
        font-size: 14px;
      }

      p {
        font: ${font('default', 'bold', '30px/1')};
        margin: 0;
        white-space: nowrap;

        span {
          display: inline-block;
          padding: 6px;
          font: ${font('default', 'normal', '12px/1')};
          color: ${props => props.theme.palette.general.light};
          background: ${props => props.theme.palette.general.strong};
          border-radius: 4px;
          margin-left: 8px;
          vertical-align: middle;
        }
      }
    }
  }
`

export const ProductQtyWrapper = styled.div`
  margin: 0 20px;

  label {
    display: block;
    font: ${font('default', 'normal', '14px/1.5')};
    margin-bottom: 5px;
  }

  input {
    border-radius: 4px;
    height: 40px;
    width: 50px;
    text-align: center;
    border: 1px solid ${props => props.theme.palette.general.grey};

    &:focus {
      outline: none;
      border-color: ${props => props.theme.palette.general.greyDark};
    }
  }

  > div {
    display: inline-block;
    position: relative;
    ${bp('sm', 'min-width')`
    &::after,
    &::before {
      content: '';
      position: absolute;
      right: 2px;
      width: 20px;
      height: 20px;
      pointer-events: none;
      background: #fff url(${arrowDown}) center no-repeat;
      background-size: 12px;
    }
  `}

    &::after {
      margin-top: 6px;
      transform: rotate(180deg);
    }

    &::before {
      margin-bottom: 6px;
      bottom: 0;
    }
  }
`

export const ModalExtraWrapper = styled.div`
  margin-top: 10px;

  > p {
    margin-top: 10px;
  }
`
